<template>
  <div>
    <modal-form modal-id="add-pbn" v-if="user.admin">
      <div slot="title">Add Pbn</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Domain</div>
            <div class="col-lg-8"><textarea name="" v-model="pbn['domain']" class="form-control"></textarea></div>
          </div>
          <div class="row">
            <div class="col-lg-4">Client</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['client']" :options="filters.clients" label="name" index="id" @change="pbn['group'] = null;"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">Type</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['type']" :options="pbnTypes"></v-select>
            </div>
          </div>
           <div class="row">
            <div class="col-lg-4">Category</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['category']" :options="filters.categories"></v-select>
            </div>
          </div>
          <div class="row" v-if="pbn['client']">
            <div class="col-lg-4">Group</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['group']" :options="filters.groupsByClient[pbn['client']]" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">Order</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['order']" :options="filters.orders" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">Hosting</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['hosting']" :options="filters.hosts" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">Software</div>
            <div class="col-lg-8">
              <v-select v-model="pbn['software']" :options="['wordpress', 'archivarix']"></v-select>
            </div>
          </div>
          <div class="row">
          <div class="col-lg-4">Create staging</div>
            <div class="col-lg-8">
              <input type="checkbox" v-model="pbn['staging']">
            </div>
          </div>
          <div class="row">
          <div class="col-lg-4">Build Flow</div>
            <div class="col-lg-8">
              <input type="checkbox" v-model="pbn['buildFlow']">
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-primary" @click="addPbn">Save</button>
      </div>
    </modal-form>
    <modal-form modal-id="save-list">
      <div slot="title">Save List</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">List Name:</div>
            <div class="col-lg-8">
              <input type="text" class="form-control" v-model="createdListName">
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-4">Sites added to the list:</div>
            <div class="col-lg-8">
              <div v-if="!showAllSites">
                <ul v-for="siteId in checkedSites.slice(0, 5)" :key="siteId">
                  <li>{{ sites.filter(s => s.id === siteId).map(s => s.domain).join() }}</li>
                </ul>
              </div>
              <div v-else>
                <ul v-for="siteId in checkedSites" :key="siteId">
                  <li>{{ sites.filter(s => s.id === siteId).map(s => s.domain).join() }}</li>
                </ul>
              </div>
              <div v-if="checkedSites.slice(0, 5).length !== checkedSites.length" class="m-t-md">
                <span>Showing <strong>{{ checkedSites.slice(0, 5).length }}</strong> sites out of <strong>{{ checkedSites.length }}</strong></span>
                <button class="btn btn-xs m-l-md" >
                  <span v-if="!showAllSites" @click="showAllSites = true">Show all sites</span>
                  <span v-else @click="showAllSites = !showAllSites">Show first 5 sites</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-sm btn-primary" @click="saveList">Save List</button>
      </div>
    </modal-form>
    <modal-form modal-id="run-actions-on-list">
      <div slot="title">Run Actions On List</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-12">
              <button :class="'btn btn-sm button ' + (!showSavedLists ? ' btn-primary' : '')"  @click="changeView">Selected Results</button>
              <button :class="'btn btn-sm ' + (showSavedLists ? ' btn-primary' : '')"  @click="showSavedLists = true">Saved Lists</button>
            </div>
            <div v-if="showSavedLists" class="col-lg-12 m-t-md">
              <div class="row">
                <div class="col-lg-4">Action to run:</div>
                <div class="col-lg-8">
                  <v-select
                    placholder="Actions to run"
                    :options="actionsList"
                    index="action"
                    label="text"
                    v-model="actionsToRun"
                  ></v-select>
                </div>
              </div>
              <div class="row m-t-md">
                <div class="col-lg-4">List to run the action on:</div>
                <div class="col-lg-8">
                  <v-select
                    :options="savedLists"
                    label="name"
                    v-model="selectedList"
                  ></v-select>
                </div>
              </div>
            </div>
            <div v-else class="col-lg-12 m-t-md">
              <div v-if="checkedSites.length">
                <div class="row">
                  <div class="col-lg-4">Action to run:</div>
                  <div class="col-lg-8">
                    <v-select
                      placholder="Actions to run"
                      :options="actionsList"
                      v-model="actionsToRun"
                      index="action"
                      label="text"
                    ></v-select>
                  </div>
                </div>
                <div class="m-t-sm" v-if="actionsToRun">
                  <span>Run <strong>{{ actionsToRun }}</strong> on <strong>{{ checkedSites.length }}</strong> selected sites</span>
                  <component :is="actionsToRun" :items="checkedSites"></component>
                </div>
              </div>
              <div v-else>
                <span>There are no selected sites yet.</span>
                <span>Please select some sites first!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-sm btn-primary" @click="runActions">Run Actions</button>
      </div>
    </modal-form>
    <div class="col-lg-12">
      <div class="col-lg-12">
        <button :class="'btn btn-sm m-b-sm ' + (editMode ? 'btn-primary' : 'btn-white')" @click="editMode = !editMode" v-if="user.admin">Edit mode</button>
        <button v-if="sites.length > 0" class="btn btn-sm m-b-sm btn-white" @click="createListMode = !createListMode">
          <span v-if="!createListMode">Create List</span>
          <span v-else>Exit Create List Mode</span>
        </button>
        <button v-if="createListMode" :disabled="!checkedSites.length" class="btn btn-sm m-b-sm btn-primary" data-toggle="modal" data-target="#save-list">Save List</button>
        <div class="pull-right">
          <button class="btn btn-sm m-b-sm btn-primary" data-toggle="modal" data-target="#run-actions-on-list">Run Actions On List</button>
        </div>
      </div>
    </div>
    <div class="table-responsive col-lg-12">
      <!-- OLD FORMAT
      <button :class="'btn btn-sm m-b-sm ' + (editMode ? 'btn-primary' : 'btn-white')" @click="editMode = !editMode" v-if="user.admin">Edit mode</button>
      <button v-if="sites.length > 0" class="btn btn-sm m-b-sm btn-white" @click="createListMode = !createListMode">
        <span v-if="!createListMode">Create List</span>
        <span v-else>Exit Create List Mode</span>
      </button>
      <button v-if="createListMode" :disabled="!checkedSites.length" class="btn btn-sm m-b-sm btn-primary" data-toggle="modal" data-target="#save-list">Save List</button>
      <div class="pull-right">
        <button class="btn btn-sm m-b-sm btn-primary" data-toggle="modal" data-target="#run-actions-on-list">Run Actions On List</button>
      </div> -->
      <aDataTable :data="sites">
        <template #columns>
        <tr>
          <th>
            <input type="checkbox" class="form-check-input m-r-md" v-model="isCheckAll" @change="selectDeselectAllSites">
          </th>
          <th>Domain</th>
          <th>Client</th>
          <th>Group</th>
          <th>Lang</th>
          <th>Tags</th>
          <th v-if="user.admin">Registrar</th>
          <th>Expires</th>
          <th>Posts</th>
          <th title="Last Post Update">Update</th>
          <th>Links</th>
          <th>Topic</th>
          <th>MajRD</th>
          <th>MozDa</th>
          <th>SemKw</th>
          <th>SemTr</th>
          <th>MajTf</th>
          <th>MajCf</th>
          <th>AHDr</th>
          <th>AHRd</th>
        </tr>
        </template>
        <template #rows>
          <tr v-for="site in sites" :key="site.id">
            <td>
              <input type="checkbox" :value="site.id" v-model="checkedSites" @input="updateSelection(site)">
            </td>
            <td>
              <pbn :pbn="site"></pbn>
            </td>
            <td :title="site.client ? site.client.name : '?'">{{ site.client ? shorten(site.client.name, 8) : '/'}}</td>
            <td :title="site.group ? site.group.name : '/'">
            <v-select
              v-if="editMode"
              :options="filters.groups"
              label="name"
              index="id"
              :value="site.group"
              @input="updatePbn($event, 'group', site.domain)"
            ></v-select>
            <span v-else>{{ site.group ? shorten(site.group.name, 8) : '/'}}</span>
          </td>
          <td :title="site.language.join(',')">{{ shorten(site.language.join(','), 8) }}</td>
          <td>
            <span v-if="!editMode">
              <span v-for="(tag, i) in site.tags" :key="tag + site.id" class="label label-primary m-r-xs" :title="tag" v-if="i < 2">{{ shorten(tag, 5) }}</span>
              <span v-if="site.tags.length > 2" class="label label-primary m-r-n" :title="site.tags.join(',')">+{{ site.tags.length - 2 }}</span>
            </span>
            <v-select multiple taggable push-tags :options="filters.tags" :value="site.tags" :ref="'tagsFor' + site.id" @input="updateTags(site.domain, ...arguments)" v-else></v-select>
          </td>
          <td v-if="user.admin" :title="site.registrar ? site.registrar.name : '?'">
            <span v-if="editMode">
                <v-select
                  :options="filters.registrars"
                  label="name"
                  :value="site.registrar ? site.registrar.id : null"
                  index="id"
                  @input="updatePbn($event, 'registrar', site.domain)"
                ></v-select>
              </span>
              <span v-else>
                {{ site.registrar ? shorten(site.registrar.name, 10) : '/' }}
              </span>
            </td>
            <td>
              <i class="fa fa-warning" v-if="site.expiresIn < 1 && site.expiresIn > -90" style="color: red;" title="Expired!"></i>
              <span
                :class="!site.expiresIn || site.expiresIn > 30 ? 'green' : (site.expiresIn > 7 ? 'orange' : 'red')"
                :title="site.expires ? $moment(site.expires.date).format('DD.MM.YYYY') : '?'"
                v-if="site.expiresIn > -90"
              >
                {{ site.expiresIn || '?' }}
              </span>
              <span v-else style="color: orange;">?</span>
            </td>
            <td :title="site.content && site.content.contentCount > 0 ? 'Posts: ' + site.content.posts + ' | Pages: ' + site.content.pages: 0">
              {{ site.content ? site.content.contentCount : '?' }}
            </td>
            <td>
              <span v-if="site.content && site.content.lastUpdate">{{ site.content.lastUpdate | aTime('DD.MM.YYYY') }}</span>
              <span v-else>/</span>
            </td>
            <td>
              <div v-if="site.linkProfile" v-for="tag in site.linkProfile" :key="tag" class="label label-primary m-r-xs" :title="tag">{{ shorten(tag, 5) }}</div>
            </td>
            <td :title="site.stats.maj ? site.stats.maj.topics.t0 : '/'">{{ site.stats.maj ? shorten(site.stats.maj.topics.t0, 10) : '/' }}</td>
            <td>{{ site.stats.maj ? site.stats.maj.rd : '/' }}</td>
            <td>{{ site.stats.moz ? site.stats.moz.da : '/'}}</td>
            <td>{{ site.stats.sr ? site.stats.sr.keywords : '/' }}</td>
            <td>{{ site.stats.sr ? site.stats.sr.traffic : '/' }}</td>
            <td>{{ site.stats.maj ? site.stats.maj.tf : '/' }}</td>
            <td>{{ site.stats.maj ? site.stats.maj.cf : '/' }}</td>
            <td>{{ site.stats.ahrefs ? site.stats.ahrefs.dr : '/' }}</td>
            <td>{{ site.stats.ahrefs ? site.stats.ahrefs.rd : '/' }}</td>
          </tr>
        </template>
      </aDataTable>
    </div>
    <div v-if="sitesLoaded">
      <button class="btn btn-primary btn-sm pull-right" @click="searchSites(false)">Load more</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Values } from '../../../mixins/helperMixin'
import axios from 'axios'
import ModalForm from '../../Helpers/Modal/Form'
import PbnListItem from './PbnListItem'

import CreateOrderModalList from '../Lists/ModalActions/CreateOrder'

export default {
  data () {
    return {
      sitesLoaded: false,
      editMode: false,
      createListMode: false,
      showAllSites: false,
      showSavedLists: true,
      createdList: [],
      checkedSites: [],
      checkedSitesList: [],
      isCheckAll: false,
      actionsList: [
        {
          action: 'create-order',
          text: 'Create Order'
        }
      ],
      actionsToRun: null,
      selectedList: [],
      createdListName: '',
      tagsFor: {},
      pbn: {
        buildFlow: true
      },
      // obj to hold sample data for saved lists. when API is up, savedLists will gets its values from there
      // right now, we add value to it from saveList method. data is lots when page is refreshed tho.
      savedLists: []
    }
  },
  mixins: [Values],
  components: {
    modalForm: ModalForm,
    pbn: PbnListItem,
    createOrder: CreateOrderModalList
  },
  computed: {
    ...mapGetters({
      sites: 'getPbns',
      filters: 'getFilters',
      user: 'getUser',
      pbnTypes: 'getPbnTypes'
    })
  },
  methods: {
    updateTags (domain, value) {
      axios.patch('/pbn/site/' + domain, {
        tags: value
      }).then(r => {
        this.$toastr.success('PBN Tags updated', 'Disco Disco')
      }).catch(e => {
        this.$toastr.error(e, 'Tag Update Failed')
      })
    },
    addPbn () {
      if (!this.pbn.domain || this.pbn.domain.length < 5) {
        this.$toastr.error('Please input a domain')
        return
      }
      axios.post('/pbn', {
        domain: this.pbn.domain,
        client: this.pbn.client,
        staging: !!this.pbn.staging,
        buildFlow: !!this.pbn.buildFlow,
        category: this.pbn.category,
        order: this.pbn.order || null,
        group: this.pbn.group || null,
        hosting: this.pbn.hosting || null
      })
        .then(r => {
          this.$toastr.success('Pbn successfully added', 'Way to go!')
          $('#add-pbn').modal('hide')
          this.pbn = {}
        })
        .catch(e => {
          this.$toastr.error(e, ':(')
        })
    },
    updatePbn (val, opt, domain) {
      let data = {}
      data[opt] = val
      axios.patch('/pbn/site/' + domain, data).then(r => {
        this.$toastr.success('Success!', 'Domain updated successfully')
        // Ideally refresh search? :|
      }).catch(e => {
        this.$toastr.error(e, 'Update failed')
      })
    },
    changeClient () {
      console.log(this.filters.orders.filter(function (o) {
        return o.client.id === this.client
      }, this.pbn))
    },
    selectDeselectAllSites () {
      if (this.isCheckAll === true) {
        this.checkedSites = this.sites.map(s => s.id)
        this.checkedSitesList = this.sites.map(s => s.subjectId)
      } else {
        this.checkedSites = []
        this.checkedSitesList = []
      }
    },
    async saveList () {
      if (!this.createdListName.length) {
        this.$toastr.error('Please name the created list!')
        return
      }
      let data = {
        name: this.createdListName,
        items: this.checkedSitesList
      }

      await axios.post(`/lists`, data)
      $('#save-list').modal('hide')
      this.$toastr.success('Lists saved')
      this.createdListName = ''
      this.showAllSites = false
    },
    runActions () {
      let data = {
        action: this.actionsToRun,
        list: this.selectedList ? this.selectedList : this.checkedSites
      }
      console.log(data)
    },
    changeView () {
      this.showSavedLists = false
      this.selectedList = null
    },
    updateSelection (site) {
      if (this.checkedSites.indexOf(site.id) === -1) {
        // Add to list
        this.checkedSitesList.push(site.subjectId)
      } else {
        // Remove from list
        this.checkedSitesList.splice(this.checkedSites.indexOf(site.id), 1)
      }
    }
  }
}
</script>
<style>
.green {
  color: green;
}
.orange {
  color: orange;
}
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/List.vue